var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPath62Dark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 219,
    viewBox: "0 0 235 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2353_1187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.728 161.207L196.088 107.769L195.884 108.128V107.473L179.576 82.3338C179.31 81.7974 178.968 81.261 178.562 80.784L195.884 54.3941L196.29 53.7365L211.244 30.9287C206.507 26.7483 201.363 22.9883 195.884 19.5842C192.976 17.7352 190.001 16.0614 186.885 14.5089C178.024 9.91335 168.415 6.33128 158.266 3.94054L143.446 26.5704L125.923 53.3187L125.654 53.7365L108.195 80.4255L90.4701 107.473L73.0142 134.159C67.8064 126.337 64.8956 117.203 64.8956 107.473V106.058C64.8956 97.5569 67.4399 89.2095 72.272 81.8567C72.7423 81.0831 73.2158 80.3635 73.7594 79.6492L90.6747 53.7365H90.7389L125.923 0.0592849V3.35288e-06H125.788C103.595 3.35288e-06 82.8249 5.19655 64.8956 14.3903C47.1678 23.4061 32.2837 36.3032 21.5933 51.7662C21.1871 52.4239 20.7137 53.0788 20.3074 53.7365C20.3074 53.6772 20.2372 53.7365 20.3074 53.7365C19.7699 54.5127 19.1559 55.4076 18.6856 56.2431C9.3452 71.469 4 88.9022 4 107.473C4 126.038 9.3452 143.474 18.6856 158.697C18.9543 159.118 19.2231 159.533 19.495 159.953C19.7668 160.371 20.0356 160.789 20.3074 161.147V161.207C20.7137 161.862 21.1871 162.519 21.5933 163.177C26.8683 170.818 33.1634 177.805 40.3351 184.012C47.6413 190.462 55.8943 196.014 64.8956 200.553C73.6892 205.089 83.1639 208.612 93.1763 211L108.195 188.074L125.788 161.207H125.858L125.923 161.088L143.516 134.278L156.372 153.921L161.109 161.207H161.176L186.885 200.432C190.001 198.882 192.976 197.208 195.884 195.356C210.16 186.462 222.136 174.999 231 161.625L230.728 161.207Z",
    fill: "url(#paint0_linear_2353_1187)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2353_1187",
    x: 0,
    y: 0,
    width: 235,
    height: 219,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2353_1187"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2353_1187",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2353_1187",
    x1: 267.805,
    y1: 195.796,
    x2: 12.2204,
    y2: 198.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D1F12"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath62Dark);
export default __webpack_public_path__ + "static/media/path62Dark.0bac23ab8452aecb396016d53bc0031f.svg";
export { ForwardRef as ReactComponent };